<template>

    <el-card shadow="hover">
        <span>{{order}}</span>
        <div class="desc">
            <h1>
                <a :href="card_url">{{title}}</a>
            </h1>
            <p>电话： {{phone}}</p>
            <p>地址： {{address}}</p>
        </div>
    </el-card>

</template>
  
<script>

export default {
        name: 'list_card',

        props: {
            //卡片序号
            order:{
                type: Number,
                required: true,
            },
            //卡片标题
            title:{
                type: String,
                required: true,
            },
            //卡片链接
            card_url:{
                type: String,
                required: false,
                default: '',
            },

            //卡片内容
            //电话
            phone:{
                type: String,
                required: false,
                default: '',
            },
            //住址
            address:{
                type: String,
                required: false,
                default: '',
            }
            
        },
        
        data () {
            return {
            
            }
        },

        methods: {

        },
    }

</script>
  

<style scoped>
@import '../styles/left_list_card.css';

</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-pc/left_cmpt_demo/list_card.vue